export const getComplaintPositionComponentsForCustomer = (components, complaintTypeId, customerId, area) => {
    let areaFilter = getComplaintPositionComponentsByArea(components,area);
    let customerIdFilter = getComplaintPositionComponentsByCustomerTypeId(areaFilter, customerId);
    let complaintTypeIdFilterComponents = getComplaintPositionComponentsByComplaintTypeId(customerIdFilter,complaintTypeId);
    return complaintTypeIdFilterComponents;
};

//get components by area
export const getComplaintPositionComponentsByArea = (components, area) => {
    return components.filter(x => x.area == area);
};

//get components by complaint type Id
export const getComplaintPositionComponentsByComplaintTypeId = (components, complaintTypeId) => {
    return components.filter(x => x.complaintTypeId == complaintTypeId);
};

//get components by customer type Id
export const getComplaintPositionComponentsByCustomerTypeId = (components, customerId) => {
    return components.filter(x => x.customerId == customerId);
};

//get component by component id from components collection
export const findComponentByComponentId = (components, componentId) => {
    return components.find(x => x.componentId == componentId);
};


// WEBPACK FOOTER //
// ./src/selectors/ComponentSelector.js